export { default } from './TextLink.js';
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/BaseComponents/TextLink/index.js